import { Box, Modal } from "@mui/material";
import { useMyContext } from "../../context";
import { modalStyle } from "../../MUIStyles";
import DialogsButtons from "../DialogsButtons";
import useSupport from "../../hooks/useSupport";
import { Controller } from "react-hook-form";
import { useEffect } from "react";

const AddEditDistput = () => {
  const { modalStates, handleCloseModal } = useMyContext();
  const {
    register,
    errors,
    control,
    reset,
    addUpdateDistputTypeLoading,
    handleAddUpdateDistputType,
    distputTypeById,
    setId,
  } = useSupport();

  // Reset form when modal opens/closes or when distputTypeById changes
  useEffect(() => {
    if (modalStates.addEditDistput) {
      if (distputTypeById) {
        // If we have data for editing, populate the form
        reset({
          name_ar: distputTypeById.name_ar || "",
          name_en: distputTypeById.name_en || "",
          is_active:
            distputTypeById.is_active !== undefined
              ? distputTypeById.is_active
              : true,
        });
      } else {
        // If no data (create mode), reset to default values
        reset({
          name_ar: "",
          name_en: "",
          is_active: true,
        });
      }
    }
  }, [modalStates.addEditDistput, distputTypeById, reset]);

  const handleClose = () => {
    handleCloseModal("addEditDistput");
    setId("");
  };

  // Determine title based on whether we're editing or creating
  const modalTitle = distputTypeById
    ? "Edit Dispute Type"
    : "Create Dispute Type";

  return (
    <Modal open={modalStates.addEditDistput} onClose={handleClose}>
      <Box
        sx={{
          ...modalStyle,
          maxHeight: "90vh",
          width: { lg: "600px", xs: "400px", sm: "600px" },
          overflowY: "auto",
        }}
      >
        <form
          onSubmit={handleAddUpdateDistputType}
          className="flex flex-col gap-5 items-center"
        >
          <h2 className="text-xl font-semibold">{modalTitle}</h2>
          <div className="w-full flex flex-col gap-5">
            {/* Arabic Name Field */}
            <div className="flex flex-col gap-3">
              <label htmlFor="name_ar" className="font-semibold">
                Arabic Name
              </label>
              <input
                type="text"
                id="name_ar"
                className="input-style pr-3"
                dir="rtl"
                placeholder="ادخل الاسم العربي"
                {...register("name_ar")}
              />
              {errors.name_ar && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.name_ar.message}
                </p>
              )}
            </div>

            {/* English Name Field */}
            <div className="flex flex-col gap-3">
              <label htmlFor="name_en" className="font-semibold">
                English Name
              </label>
              <input
                type="text"
                id="name_en"
                className="input-style pr-3"
                placeholder="Enter Name"
                {...register("name_en")}
              />
              {errors.name_en && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.name_en.message}
                </p>
              )}
            </div>

            {/* Active Toggle Field */}
            <div className="flex items-center justify-between">
              <h2 className="font-semibold">Active</h2>
              <Controller
                name="is_active"
                control={control}
                render={({ field }) => (
                  <button
                    type="button"
                    onClick={() => field.onChange(!field.value)}
                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer outline-none ${
                      field.value ? "bg-green-500" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        field.value ? "translate-x-5" : "translate-x-1"
                      }`}
                    />
                  </button>
                )}
              />
              {errors.is_active && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.is_active.message}
                </p>
              )}
            </div>
          </div>

          <DialogsButtons
            color="secondary"
            Btn1="Cancel"
            Btn2={
              addUpdateDistputTypeLoading
                ? "Saving..."
                : distputTypeById
                ? "Update"
                : "Save"
            }
            onClose={handleClose}
            isSubmit={true}
            disable={addUpdateDistputTypeLoading}
          />
        </form>
      </Box>
    </Modal>
  );
};

export default AddEditDistput;
